'use strict';

/**
 * Adapt the given key to use the correct financial terminology.
 * In effect, that means that invoice gets replaced by payment_invitation, if the current
 * customer has no VAT.
 */
customerZone.filter('finterm', ['Session', 'utils', function(Session, utils){
    return function(key){
        var profile = Session.profile();
        return utils.finterm(key, profile && profile.vat);
    };
}]);
